// Shared constants for the variant workflow feature
// Tools that should render a dropdown for prediction_result using backend-provided choices_json
export const ALLOWED_PREDICTION_RESULT_SELECT_TOOLS = new Set<string>([
  'SpliceAI',
  'Grantham Matrix',
  'REVEL',
  'PhyloP 100 vertebrate',
]);
